import { FC } from 'react';

import { Box, Typography } from '@mui/material';
import clsx from 'clsx';

import { useGetCurrency } from 'hooks/useGetCurrency';

import { formatMonetary } from 'helpers/numbers';

import { ITotalComponentProps } from './types';

import styles from './TotalComponent.module.scss';

export const TotalComponent: FC<ITotalComponentProps> = ({ title, error, total }) => {
  const currency = useGetCurrency();
  return (
    <Box className={clsx(styles.container, { [styles.error]: error })}>
      <Typography variant="subtitle2">{title}</Typography>
      <Typography variant="h4">{formatMonetary(total, currency.value)}</Typography>
    </Box>
  );
};
